import styled from '@emotion/styled';
import { SerializedStyles, css, keyframes } from '@emotion/react';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import ZolaLogo from '@zola/zola-ui/src/components/ZolaLogo';
import { COLORS3, SPACING, utils } from '@zola/zola-ui/src/styles/emotion';

const NAV_CLOSED_WIDTH = '74px';
const NAV_OPEN_WIDTH = '214px';

const LOGO_CLOSED_WIDTH = '36px';
const LOGO_OPEN_WIDTH = '106px';

const slideOpen = (): string => keyframes`
  100% { width: ${NAV_OPEN_WIDTH}; }
`;

const slideClose = (): string => keyframes`
  0% { width: ${NAV_OPEN_WIDTH}; }
  100% { width: ${NAV_CLOSED_WIDTH}; }
`;

const slideAnimation = (shouldSlideOpen = false) => css`
  animation: ${shouldSlideOpen ? slideOpen() : slideClose()} 500ms forwards;
`;

const fadeIn = (): string => keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

const fadeOut = (): string => keyframes`
  0% { opacity: 1; }
  100% { opacity: 0; }
`;

export const fadeAnimation = (shouldFadeIn = false, duration = '1000ms'): SerializedStyles => css`
  animation: ${shouldFadeIn ? fadeIn() : fadeOut()} ${duration} forwards;
`;

const fadeInOnlyAnimation = () => css`
  animation: ${fadeIn()} 1000ms forwards;
`;

export const VerticalNavWrapper = styled.div<{ open?: boolean }>`
  position: fixed;
  height: 100%;
  width: ${NAV_CLOSED_WIDTH};
  overflow-y: scroll;
  border-right: 1px solid ${COLORS3.BLACK_030};
  background-color: ${COLORS3.BLACK_005};
  display: flex;
  flex-direction: column;
  padding: 0 ${SPACING.SM};
  ${({ open }) => typeof open !== 'undefined' && slideAnimation(open)}
  ${utils.concealScrollbars}

  /* Fade at bottom of nav */
  &::after {
    ${({ open }) =>
      typeof open !== 'undefined' &&
      css`
        content: '';
        position: fixed;
        bottom: 0;
        left: 0;
        height: 64px;
        width: ${NAV_CLOSED_WIDTH};
        background-image: linear-gradient(to bottom, transparent, ${COLORS3.BLACK_005});
        border-right: 1px solid ${COLORS3.BLACK_030};
        pointer-events: none;
        ${slideAnimation(open)}
      `}
  }
`;

export const HomeLink = styled(LinkV2)<{ open?: boolean }>`
  margin: ${({ open }) => (open ? `${SPACING.S24} ${SPACING.SM}` : `${SPACING.S24} auto`)};
  ${({ open }) => open && fadeInOnlyAnimation()}
`;

export const StyledZolaLogo = styled(ZolaLogo)<{ open?: boolean }>`
  height: ${SPACING.S16};
  width: ${({ open }) => (open ? LOGO_OPEN_WIDTH : LOGO_CLOSED_WIDTH)};
`;

export const SecondaryLinks = styled.div<{ open?: boolean }>`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${COLORS3.BLACK_030};
  margin: ${SPACING.S24} ${SPACING.SM};
  padding: ${SPACING.S24} 0;
  width: 100%;
  max-width: 166px;
  ${({ open }) => typeof open !== 'undefined' && fadeAnimation(open)}
`;
